export default __webpack_public_path__ + "static/media/216twofloorplan.041a2528.svg";